export default "__VITE_ASSET__Cms0lpiK__"